import { QueryKey } from '@/constants/shared';
import { checkGeoCompliance } from '@/network/api';
import { useQuery } from '@tanstack/react-query';
import { useVpnBypass } from './useVpnBypass';

export const useCompliance = () => {
  const { bypassVpn } = useVpnBypass();

  const { data, isPending, error } = useQuery({
    queryKey: [QueryKey.Compliance],
    queryFn: async () => {
      const response = await checkGeoCompliance();
      return response;
    },
  });

  return {
    geoCompliance: {
      ...(data || {}),
      restrictAccess: bypassVpn ? false : data?.restrictAccess,
    },
    isPendingGeoCompliance: isPending,
    geoComplianceError: error,
  };
};
